export default __webpack_public_path__ + "media/images/jvqmap/marker/yellow-5888c4436759338b5f9f95f2efdf25f1.png";